import PropTypes from "prop-types";
import { htmlSanitize } from "app/utils/sanitize";

import "./DVAFParagraph.scss";

const DVAFParagraph = ({ content }) => {
	let isListItem = content && content.startsWith("<li>");
	let className = isListItem ? "dvaf-paragraph--list" : "dvaf-paragraph";

	return (
		<div dangerouslySetInnerHTML={{ __html: htmlSanitize(content) }} className={className} />
	);
};

DVAFParagraph.propTypes = {
	content: PropTypes.string.isRequired,
};
export default DVAFParagraph;
